import { createGlyphComponent } from "@via-ds/icons";

export const PrideLogo = createGlyphComponent(
  "PrideLogo",
  "0 0 359 445",
  <g id="1">
    <mask
      height="262"
      id="mask0_689_4"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
      width="221"
      x="73"
      y="94"
    >
      <path
        clipRule="evenodd"
        d="M238.463 173.995L186.867 96.0575C185.048 93.3106 181.019 93.316 179.2 96.0629L127.777 174.006C123.774 180.068 128.125 188.148 135.39 188.148H140.859L103.629 240.227C99.6264 246.289 103.977 254.369 111.242 254.369H121.015L74.5234 312.649C70.5211 318.712 74.8722 326.791 82.1364 326.791H161V337.399C161 347.665 169.335 356 179.601 356H187.399C197.665 356 206 347.665 206 337.399V326.791H284.312C291.582 326.791 295.933 318.701 291.92 312.638L246.056 254.369H254.767C262.037 254.369 266.388 246.278 262.375 240.216V240.21L225.37 188.148H230.85C238.119 188.148 242.47 180.058 238.457 173.995H238.463Z"
        fill="#00A35C"
        fillRule="evenodd"
        id="Union"
      />
    </mask>
    <g mask="url(#mask0_689_4)">
      <g id="Frame 2">
        <rect
          fill="#DB3030"
          height="436"
          id="Rectangle 1"
          transform="rotate(21.5842 200.391 -30)"
          width="38.2811"
          x="200.391"
          y="-30"
        >
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#DB3030;#B45AF2;#016BF8;#00A35C;#FFC010;#F38300;#DB3030"
          />
        </rect>
        <rect
          fill="#F38300"
          height="436"
          id="Rectangle 2"
          transform="rotate(21.5842 235.057 -16.2855)"
          width="38.2811"
          x="235.057"
          y="-16.2855"
        >
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#F38300;#DB3030;#B45AF2;#016BF8;#00A35C;#FFC010;#F38300"
          />
          <animate
            attributeName="y"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="-16.2855;-16.2855;-16.2855;-16.2855;-16.2855;-16.2854;-16.2854"
          />
          <animateTransform
            attributeName="transform"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            type="rotate"
            values="21.5842 235.057 -16.2855;21.5842 235.057 -16.2855;21.5842 235.057 -16.2855;21.5842 235.057 -16.2855;21.5842 235.057 -16.2855;21.5842 235.057 -16.2854;21.5842 235.057 -16.2854"
          />
        </rect>
        <rect
          fill="#FFC010"
          height="436"
          id="Rectangle 3"
          transform="rotate(21.5842 269.724 -2.57094)"
          width="38.2811"
          x="269.724"
          y="-2.57094"
        >
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#FFC010;#F38300;#DB3030;#B45AF2;#016BF8;#00A35C;#FFC010"
          />
          <animate
            attributeName="y"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="-2.57094;-2.57094;-2.57092;-2.57092;-2.57092;-2.57104;-2.57104"
          />
          <animateTransform
            attributeName="transform"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            type="rotate"
            values="21.5842 269.724 -2.57094;21.5842 269.724 -2.57094;21.5842 269.724 -2.57092;21.5842 269.724 -2.57092;21.5842 269.724 -2.57092;21.5842 269.724 -2.57104;21.5842 269.724 -2.57104"
          />
        </rect>
        <rect
          fill="#00A35C"
          height="436"
          id="Rectangle 4"
          transform="rotate(21.5842 304.391 11.1436)"
          width="38.2811"
          x="304.391"
          y="11.1436"
        >
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#00A35C;#FFC010;#F38300;#DB3030;#B45AF2;#016BF8;#00A35C"
          />
        </rect>
        <rect
          fill="#016BF8"
          height="436"
          id="Rectangle 5"
          transform="rotate(21.5842 339.058 24.8581)"
          width="38.2811"
          x="339.058"
          y="24.8581"
        >
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#016BF8;#00A35C;#FFC010;#F38300;#DB3030;#B45AF2;#016BF8"
          />
          <animate
            attributeName="y"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="24.8581;24.8581;24.8581;24.8582;24.8582;24.8582;24.8582"
          />
          <animateTransform
            attributeName="transform"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            type="rotate"
            values="21.5842 339.058 24.8581;21.5842 339.058 24.8581;21.5842 339.058 24.8581;21.5842 339.058 24.8582;21.5842 339.058 24.8582;21.5842 339.058 24.8582;21.5842 339.058 24.8582"
          />
        </rect>
        <rect
          fill="#B45AF2"
          height="436"
          id="Rectangle 6"
          transform="rotate(21.5842 373.725 38.5726)"
          width="38.2811"
          x="373.725"
          y="38.5726"
        >
          <animate
            attributeName="y"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="38.5726;38.5727;38.5726;38.5726;38.5726;38.5728;38.5728"
          />
          <animateTransform
            attributeName="transform"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            type="rotate"
            values="21.5842 373.725 38.5726;21.5842 373.725 38.5727;21.5842 373.725 38.5726;21.5842 373.725 38.5726;21.5842 373.725 38.5726;21.5842 373.725 38.5728;21.5842 373.725 38.5728"
          />
          <animate
            attributeName="fill"
            begin="0s"
            calcMode="linear"
            dur="3s"
            fill="freeze"
            keyTimes="0;0.167;0.333;0.5;0.667;0.833;1"
            repeatCount="indefinite"
            values="#B45AF2;#016BF8;#00A35C;#FFC010;#F38300;#DB3030;#B45AF2"
          />
        </rect>
      </g>
    </g>
  </g>,
  { defaultSize: 72 },
);
